<div>
  <button class="wv-bold-button" [class.large-button]="large" [class.blue-button]="blueButton" (click)="onClick()">
    <ng-content></ng-content>
    <fa-icon *ngIf="arrow" icon="chevron-right" size="xs"></fa-icon>
  </button>
</div>
